enum IntegrationMappingType {
    Response = '00000000-0000-0000-0000-000000000003',
    Input = '00000000-0000-0000-0000-000000000001',
    Output = '00000000-0000-0000-0000-000000000002'
}

export { IntegrationMappingType };
